module.exports = __webpack_public_path__ + "static/img/200301.eecc84fe.png";